import { useMemo } from 'react';

import useMatrixContext from 'contexts/MatrixContext/useMatrixContext';
import { WorkspaceRoleV2 } from 'modules/CreateWorkspaceModal/types';
import useWorkspacesContext from 'modules/Workspaces/WorkspacesProvider/useWorkspacesContext';

const useActorWorkspaceRole = (): WorkspaceRoleV2 | null => {
  const { matrixClient } = useMatrixContext();
  const { workspaceRoles, roleAssignments } = useWorkspacesContext({ requireWorkspaceId: true });

  return useMemo(() => {
    const userId = matrixClient.getUserId();
    if (!userId) return null;

    const assignment = roleAssignments.find(({ matrixId }) => matrixId === userId);
    if (!assignment) return null;

    return workspaceRoles.find((role) => role.id === assignment.roleId) ?? null;
  }, [matrixClient, roleAssignments, workspaceRoles]);
};

export default useActorWorkspaceRole;
